import Notice from "assets/air/notice.png";
import { useNavigate } from "react-router-dom";

const NoLogin = ({ status }: { status: string }) => {
    const navigate = useNavigate();
    return (
        <div className="bg-white mx-auto items-center w-full max-w-[600px] px-[100px] py-[50px] flex flex-col responsive1200:px-[4%] responsive1200:py-[10%]">
            <div className="flex flex-col items-center text-[#333]">
                <img src={Notice} alt="Notice" />
                <p className="mt-7 text-[25px] font-[500]">로그인 후 이용이 가능합니다.</p>
                <p className="text-[#666] mt-3">더 많은 내용을 보시려면 로그인해주세요.</p>
            </div>
            <button
                onClick={() => navigate("/login")}
                className={`text-white mt-[45px] w-[185px] h-[51px] text-lg font-[500] ${status === "air" ? "bg-air" : status === "morning" ? "bg-morning" : status === "quick" ? "bg-quick" : "bg-express"}`}
            >
                로그인
            </button>
        </div>
    );
};

export default NoLogin;
